import { Box, CircularProgress } from '@mui/material';
import React, { Suspense } from 'react';
import { useAddServiceToAccountMutation, useRemoveServiceFromAccountMutation } from '../../../api/recalc/endpoints/accountsApiSlice';
import { useGetUnitsByAccountQuery } from '../../../api/recalc/endpoints/unitsApiSlice';
import { useGetSensorsByAccountIdQuery } from '../../../api/recalc/endpoints/sensorsApiSlice';

const ServiceManagementDrawer = React.lazy(() =>
    import('remote/ServiceManagementDrawer').catch(() => ({
      default: () => <div>Failed to load</div>,
    }))
  );

const AccountDrawerContainer = ({ isOpen, onClose, account }) => {

  
  const [addServiceToAccount, { isLoading: isAddingService }] = useAddServiceToAccountMutation();
  const [removeServiceFromAccount, { isLoading: isRemovingService }] = useRemoveServiceFromAccountMutation();

  const { data: units } = useGetUnitsByAccountQuery(account.AccountId, {skip: !account?.AccountId})
  const { data: sensors } = useGetSensorsByAccountIdQuery(account.AccountId, {skip: !account?.AccountId})

  const handleAddService = async (serviceId) => {
    try {
      await addServiceToAccount({ accountId: account.AccountId, serviceId }).unwrap();
    } catch (error) {
      console.error('Error adding service:', error);
    }
  }

  const handleRemoveService = async (serviceId) => {
    try {
      await removeServiceFromAccount({ accountId: account.AccountId, serviceId }).unwrap();
    } catch (error) {
      console.error('Error removing service:', error);
    }
  }

  return (
    <Suspense fallback={
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', verticalAlign: 'center' }}>
        <CircularProgress />
      </Box>
    }>
          <ServiceManagementDrawer account={{...account, 
          jsonObjects: 
            [
              {object: account, name: 'Account'},
              {object: units, nameKey: 'Name', idKey: 'UnitId', name: 'Units'},
              {object: sensors, nameKey: 'SensorType', idKey: 'SensorId', name: 'Sensors'},
              ]}} open={isOpen} onClose={onClose} handleAddService={handleAddService} handleRemoveService={handleRemoveService} />
      </Suspense>
  );
};

export default AccountDrawerContainer;